import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgEdit = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12.434 2.36a.21.21 0 0 1 .21.21v1.47a.21.21 0 0 1-.21.21h-8.4v17.22h17.22v-8.4a.21.21 0 0 1 .21-.21h1.47a.21.21 0 0 1 .21.21v9.45a.84.84 0 0 1-.84.84H2.984a.84.84 0 0 1-.84-.84V3.2a.84.84 0 0 1 .84-.84Zm7.237 0c.055 0 .108.018.15.06l3.263 3.26a.21.21 0 0 1 0 .297L12.166 16.87a.218.218 0 0 1-.141.06l-3.098.077h-.01a.42.42 0 0 1-.42-.425l.05-3.122c0-.055.023-.107.06-.147L19.522 2.42a.217.217 0 0 1 .15-.06Zm0 2.283-9.458 9.437-.018 1.218 1.2-.029 9.463-9.442-1.187-1.184Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgEdit)
const Memo = memo(ForwardRef)
export default Memo
